import { createSlice } from "@reduxjs/toolkit";

import {
  getNotifications,
  getUnreadNotificationCount,
  markAllNotificationsRead,
  markNotificationRead,
} from "../../api/notificationAPI";

export const NOTIFICATION_PAGE_SIZE = 10;

const initialState = {
  status: "idle",
  items: [],
  unread: 0,
};

const notificationsSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    setLoading: (state) => {
      state.status = "loading";
    },
    setNotifications: (state, action) => {
      state.status = "succeeded";
      state.items = action.payload ?? [];
    },
    setError: (state) => {
      state.status = "failed";
    },
    setUnread: (state, action) => {
      state.unread = action.payload ?? 0;
    },
    setRead: (state, action) => {
      const item = state.items.find((notification) => notification.id === action.payload.id);
      if (item && !item.readAt) {
        item.readAt = action.payload.readAt;
        state.unread = Math.max(0, state.unread - 1);
      }
    },
    setAllRead: (state, action) => {
      state.items.forEach((notification) => {
        notification.readAt = notification.readAt ?? action.payload;
      });
      state.unread = 0;
    },
  },
});

export const { setLoading, setNotifications, setError, setUnread, setRead, setAllRead } =
  notificationsSlice.actions;
export const selectNotifications = (state) => state.notifications ?? initialState;

// Polled in the background, so a failure is dropped rather than surfaced on every tick.
export const handleGetUnreadNotificationCount = () => async (dispatch) => {
  try {
    const response = await getUnreadNotificationCount();
    dispatch(setUnread(response.data?.count));
  } catch (_) {}
};

export const handleGetNotifications = () => async (dispatch) => {
  dispatch(setLoading());
  try {
    const response = await getNotifications(NOTIFICATION_PAGE_SIZE);
    dispatch(setNotifications(response.data?.content));
  } catch (_) {
    dispatch(setError());
  }
};

export const handleMarkNotificationRead = (id) => async (dispatch) => {
  try {
    const response = await markNotificationRead(id);
    dispatch(setRead({ id, readAt: response.data?.readAt ?? new Date().toISOString() }));
  } catch (_) {}
};

export const handleMarkAllNotificationsRead = () => async (dispatch) => {
  try {
    await markAllNotificationsRead();
    dispatch(setAllRead(new Date().toISOString()));
  } catch (_) {}
};

export default notificationsSlice.reducer;
